export const useSubmitFeedback = async (data) => {
  localStorage.removeItem("createOrder");
  return useFetchSafely(() => `customer-general-feedback`, {
    method: "POST",
    body: data,
  });
};

export const useUpdateFeedback = async (id, data) => {
  localStorage.removeItem("createOrder");
  return useFetchSafely(() => `customer-general-feedback/${id}`, {
    method: "POST",
    body: data,
  });
};
